<template>
  <div class="tw-w-full">
    <div class=" tw-text-black tw-text-sm tw-font-semibold">
      {{ label }}
    </div>
    <div
      class="tw-relative"
      :class="{
        ' tw-pointer-events-none': disable
      }"
    >
      <input
        :type="
          password && showPassword ? 'password' : number ? 'number' : 'text'
        "
        role="presentation"
        autocomplete="off"
        :placeholder="placeholder"
        :value="value"
        class="tw-w-full tw-rounded-large tw-border-solid tw-border tw-border-black-50 tw-p-3 tw-font-semibold tw-transition-all tw-outline-none
        placeholder:tw-text-black-200 placeholder:tw-text-sm
        tw-text-black
        focus:tw-border-mint"
        :class="{
          'placeholder:tw-text-black-100 tw-bg-black-50 tw-text-black-100': disable,
          'tw-border-red tw-bg-red-50 placeholder:tw-text-red tw-text-red':
            error !== ''
        }"
        @input="handleInput"
        @blur="handleBlur"
        :maxlength="maxLength"

      />
      <div
        v-if="password"
        @click="handleShowPassword"
        class="tw-absolute tw-top-3 tw-right-3 tw-cursor-pointer"
      >
        <lgk-icon
          :icon="showPassword ? 'eye-off' : 'eye'"
          class="tw-h-6 tw-w-6"
          :class="{
            'tw-fill-black-100': disable,
            'tw-fill-black-400': !disable
          }"
        />
      </div>
    </div>
    <div class=" tw-text-red tw-font-semibold tw-text-sm ">{{ error }}</div>
  </div>
</template>

<script>
import LgkIcon from './LgkIcon.vue'
export default {
  components: { LgkIcon },
  name: 'LgkTextfield',
  props: {
    label: {
      type: String,
      default: 'Text'
    },
    errorMessage: {
      type: String,
      default: ''
    },
    update: {
      type: Function,
      default: () => {}
    },
    disable: {
      type: Boolean,
      default: false
    },
    onlyRead: {
      type: Boolean,
      default: false
    },
    password: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    value: {
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    number: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: 100
    }
  },
  data () {
    return {
      showPassword: true,
      error: this.errorMessage
    }
  },
  methods: {
    handleInput (event) {
      this.error = ''
      this.$emit('input', event.target.value)
    },
    handleBlur (event) {
      if (this.required && !event.target.value) {
        this.error = 'This field is required'
      }
    },
    handleShowPassword () {
      this.showPassword = !this.showPassword
    }
  }
}
</script>
